/*
 * Configuration settings for CityCAD Online web application
 */
export const apiBaseUrl = 'https://www.holisticcity.co.uk/api';
// export const apiBaseUrl = 'https://www.holisticcity.co.uk/api-dev';

export const apiCIMToolkitUrl = 'https://www.holisticcity.co.uk/api';
// export const apiCIMToolkitUrl = 'https://www.holisticcity.co.uk/api-dev';

export const isDebug = false;

export const citycadMajorVersion = 3;
export const helpArticlePath = `./help/article/`;

export const passwordResetUrl = "https://www.holisticcity.co.uk/client";
export const clientAreaUrl = "https://www.holisticcity.co.uk/client/clientarea.php";
export const createAccountUrl = "https://www.holisticcity.co.uk/client/register.php";

export const authCookieName = "hclsession";
export const cookieExpirySeconds = 86400;
export const titleCheckIntervalMilliseconds = 500;
export const timeBeforeAlertMessageDisappearsMilliseconds = 2500;

export const defaultPageTitle = "CityCAD Online";

export const frontPageContent = {
  title: "",
  articles: [
    {
      id: 45,
      title: 'Getting Started',
      icon: 'airplane2_starting'
    },
    // {
    //   id: 12,
    //   title: 'Cloud storage',
    //   icon: 'cloud_upload'
    // },
    {
      id: 3,
      title: 'Setting up your model',
      icon: 'mobile_crane'
    },
    {
      id: 1,
      title: 'Resolving problems',
      icon: 'sign_warning'
    }
  ]
};

const hclColourPalette = {
  lightGreen: "#dfead2",
  mediumGreen: "#669933",
  lightGrey: "#cdcdcd",
  veryLightGrey: "#efefef",
  mediumGrey: "#676767",
  darkGrey: "#343434",
  emphasis: "rgb(224, 153, 83)",
  dangerBackground: "#ffbbbb",
  dangerBorder: "#fca5a5",
  dangerText: "#aa0000",
  citycadBlue: "#0068b0"
};

/*
 * Design theme for HCL React apps
 */
const hcl = {
  colours: {
    alertBackground: hclColourPalette.dangerBackground,
    alertText: hclColourPalette.dangerText,
    alertBorder: hclColourPalette.dangerBorder,
    main: hclColourPalette.mediumGreen,
    emphasis: hclColourPalette.emphasis,
    formBackground: hclColourPalette.veryLightGrey,
    headerSelectedColour: hclColourPalette.lightGreen,
    heading: hclColourPalette.darkGrey,
    subheading: hclColourPalette.mediumGrey,
    border: hclColourPalette.lightGrey,
    // link: hclColourPalette.mediumGreen,
    link: '#ffffff',
    activeSubscription: hclColourPalette.mediumGreen,
    inactiveSubscription: hclColourPalette.mediumGrey,
    adminUserIcon: hclColourPalette.mediumGreen,
    standardUserIcon: hclColourPalette.lightGrey,
    citycadBlue: hclColourPalette.citycadBlue
  },
  fonts: {
    main: "Arial",
    heading: "Poppins, sans-serif",
    subheading: "sans-serif"
  },
  sizes: {
    main: "0.9em",
    header: "0.75em",
    headerIcon: 14
  },
  pageWidthForSingleColumnHelpResults: "600px",
  libraryThumbnailMaxWidth: "100px"
};

export const theme = hcl;

export const getLicenceColour = status => {
  if (status === 'Active')
    return hcl.colours.activeSubscription;
  else if (status === 'Terminated')
    return hcl.colours.inactiveSubscription;
  else
    return 'black';
};
